import { useEffect } from 'react';
import ShuttleIcon from '@/assets/icons/airport-shuttle-white.svg?react';
import { ServiceReservationGuide } from '@/components/ServiceReservationGuide';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function BusAlreadyReservedGuide() {
    const navigate = useNavigate();
    const { user, checkAuth } = useAuth();
    const reservation = user?.todayBusReservation;

    useEffect(() => {
        let isMounted = true;

        const verifyReservation = async () => {
            const refreshedUser = await checkAuth({ showLoading: false });

            if (!isMounted) {
                return;
            }

            if (refreshedUser?.serviceAccess?.busEnabled === false) {
                navigate('/bus/access-restricted', { replace: true });
                return;
            }

            if (!refreshedUser?.todayBusReservation) {
                navigate('/bus', { replace: true });
            }
        };

        void verifyReservation();

        return () => {
            isMounted = false;
        };
    }, [checkAuth, navigate]);

    return (
        <ServiceReservationGuide
            icon={<ShuttleIcon className="icon-svg" />}
            title="별빛버스 예약 안내"
            description={
                <>
                    오늘 이미 별빛버스 예약이 있어 추가 예약을 진행할 수 없습니다.<br />
                    예약 시간 변경을 원하시면, '예약 내역 확인' 에서 기존 예약 취소 후 다시 시도해주세요.
                </>
            }
            detailLabel="오늘 예약한 버스"
            detailValue={reservation ? `${reservation.busName} (${reservation.departureTime.substring(0, 5)} 출발)` : '-'}
            iconBackgroundColor="#00D1AB"
        />
    );
}
